<div class="step-content">
  <app-dashboard-box [title]="'common.title.alarm-administration' | translateSafe"
                     class="transparent filter"
                     icon="filter_alt">

    <section class="filter-section">
      <app-input-select [formData]="statusFilterConfig" />
      <app-input-select [formData]="severityFilterConfig" />
      <app-input-select [formData]="alarmTypeFilterConfig" />
    </section>
  </app-dashboard-box>

  <app-dashboard-box [buttonLabel]="alarmCountLabel"
                     [title]="'common.title.alarm-list' | translateSafe"
                     icon="list">
    <app-table [tableConfig]="tableConfig"
               [tableRows]="tableRows"
               [loading]="loading" />
  </app-dashboard-box>
</div>
